import { render, staticRenderFns } from "./HotelDetail.vue?vue&type=template&id=2c41f2cb&scoped=true&"
import script from "./HotelDetail.vue?vue&type=script&lang=js&"
export * from "./HotelDetail.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetail.vue?vue&type=style&index=0&id=2c41f2cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41f2cb",
  null
  
)

export default component.exports